const i18n = {
  'dateTime': {
    'dateTimeRangeErrorTitle': '開始/結束時間錯誤',
    'startTimeIsAfterEndTime': '所選定的開始時間在結束時間之後',
  },
}
export default i18n